export const APP_TYPES = {
  JIJIAN: "jijian", // 第一个应用
  CAIPIANOS: "caipianos", // 第二个应用
  UNKNOWN: "unknown"
};

/**
 * 环境类型枚举
 */
export const ENV_TYPES = {
  PROD: "production",
  TEST: "local",
  DEV: "development"
};

/**
 * 初始化全局应用配置
 */
export const initAppConfig = () => {
  const { hostname, protocol } = window.location;

  // 定义域名匹配规则
  const DOMAIN_RULES = [
    // 第一个应用（棉花果mini）
    {
      domain: "www.jijianwang.cn",
      appType: APP_TYPES.JIJIAN,
      env: ENV_TYPES.PROD
    },
    {
      domain: "local-dev.58mhg.com",
      appType: APP_TYPES.JIJIAN,
      env: ENV_TYPES.DEV,
      port: "3010"
    },

    // 第二个应用（编菲助手）
    {
      domain: "www.caipianos.com",
      appType: APP_TYPES.CAIPIANOS,
      env: ENV_TYPES.PROD
    },
    {
      domain: "bfzs.jijianwang.cn",
      appType: APP_TYPES.CAIPIANOS,
      env: ENV_TYPES.DEV
    }
  ];

  let appTypeFromEnv = APP_TYPES.UNKNOWN;
  let envFromEnv = ENV_TYPES.LOCAL;

  if (import.meta.env.VITE_API_URL) {
    const apiUrl = import.meta.env.VITE_API_URL.toLowerCase();

    if (apiUrl.includes("www.jijianwang.cn") || apiUrl.includes("local-dev.58mhg.com")) {
      appTypeFromEnv = APP_TYPES.JIJIAN;
    } else if (apiUrl.includes("www.caipianos.com") || apiUrl.includes("dev.jijianwang.cn")) {
      appTypeFromEnv = APP_TYPES.CAIPIANOS;
    }

    if (apiUrl.includes("test")) {
      envFromEnv = ENV_TYPES.DEV;
    } else if (apiUrl.includes("localhost") || apiUrl.includes("192.168")) {
      envFromEnv = ENV_TYPES.TEST;
    }
  }

  // 匹配当前域名
  let currentConfig = {
    appType: appTypeFromEnv,
    env: envFromEnv,
    baseUrl: `${protocol}//${hostname}`
  };


  for (const rule of DOMAIN_RULES) {
    if (hostname === rule.domain || hostname.endsWith(`.${rule.domain}`) || (rule.port && `${hostname}:${rule.port}` === `${rule.domain}:${rule.port}`)) {
      currentConfig = {
        appType: rule.appType,
        env: rule.env,
        baseUrl: `${protocol}//${hostname}${rule.port ? `:${rule.port}` : ""}`
      };
      break;
    }
  }

  // 设置全局变量
  window.__APP_CONFIG__ = {
    ...currentConfig,
    // 根据应用类型和环境生成API地址
    apiBaseUrl: generateApiUrl(currentConfig.appType, currentConfig.env)
  };

  console.log("当前应用配置:", window.__APP_CONFIG__);
};

/**
 * 生成API基础地址
 */
function generateApiUrl(appType, env) {
  const API_MAP = {
    [APP_TYPES.JIJIAN]: {
      [ENV_TYPES.PROD]: "https://www.jijianwang.cn",
      [ENV_TYPES.DEV]: "http://local-dev.58mhg.com:3010"
    },
    [APP_TYPES.CAIPIANOS]: {
      [ENV_TYPES.PROD]: "https://www.caipianos.com",
      [ENV_TYPES.DEV]: "http://dev.jijianwang.cn"
    },
    [ENV_TYPES.TEST]: {
      [ENV_TYPES.PROD]: "http://local-dev.58mhg.com:3010",
      [ENV_TYPES.DEV]: "http://local-dev.58mhg.com:3010"
    }
  };

  return API_MAP[appType]?.[env] || window.location.origin;
}
